import { Appointment, AppointmentStatus } from "../api/client";
import { DateTime } from "luxon";
import { stringifyAppointmentStatus } from "../helpers/stringHelpers";
import { ExclamationLg, PersonFillCheck, PersonFillExclamation, PersonFillSlash } from "react-bootstrap-icons";
import classNames from "classnames";

interface StudentAppointmentElementProps {
    app: Appointment
}

const iconClasses = classNames('w-8 h-8 mt-3 mr-2')

const AppointmentStatusIcon = (status: AppointmentStatus | undefined) => {
    switch (status) {
        case AppointmentStatus.Processed:
            return <PersonFillCheck className={iconClasses}/>;
        case AppointmentStatus.Canceled:
            return <PersonFillSlash className={iconClasses}/>;
        case AppointmentStatus.Waiting:
            return <PersonFillExclamation className={iconClasses}/>;
        default:
            return <ExclamationLg className={iconClasses}/>
    }
}

export function StudentAppointmentElement({app}: StudentAppointmentElementProps): JSX.Element {
    return (
    <div key={app.id} className='border bg-gray-100 dark:bg-gray-600 dark:border-gray-600 rounded-lg mb-4 p-4 flex align-middle'>
        <div className="border-r-2 border-gray-300 mr-3">
            {AppointmentStatusIcon(app.status)}
        </div>
        <div className="">
            <h3>Student checked-in for appointment on {app.createdAt?.toLocaleString(DateTime.DATETIME_FULL)}</h3>
            <p className="font-bold">Status: <span className="font-normal"> 
                {stringifyAppointmentStatus(app.status!)} {app.advisorUser?.fullName ?? 'an unknown advisor'} {app.status == AppointmentStatus.Waiting ? 'since' : 'on'} {app.wentToAdvisorTime && app.status == AppointmentStatus.Processed 
                ? `${app.wentToAdvisorTime.toLocaleString(DateTime.DATETIME_FULL)}` 
                : `${app.createdAt?.toLocaleString(DateTime.DATETIME_FULL)}`} </span>
            </p>
        </div>
    </div>
    );
}